import React from 'react';
import PropTypes from 'prop-types';

import { findChildByIndex, findChildByPropValue  } from '../../Utilities/ReactUtil';

export class Stages extends React.Component {

    static propTypes = {
        // Active child stage index
        activeStage: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
    }

    static defaultProps = {
        activeStage: 0
    }

    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div>{findChildByPropValue(this.props.children, 'stageIndex', this.props.activeStage)}</div>
        );
    }
}

export class Stage extends React.Component {

    static propTypes = {
        stageIndex: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
    }

    constructor(props) {
        super(props);
    }

    render() {
        return <div>{this.props.children}</div>
    }
}